
import { useEffect } from 'react';
import OneCallback from './OneCallback'


function CallbackList({ info, handleEdit }) {
    
    const hasScrollbar = () => {
        const tablebody = document.querySelector('tbody');
        if(info.length*35 <= tablebody.clientHeight) tablebody.style.width = '100%'
        else tablebody.style.width = 'calc(100% + 10px)'
    }

    useEffect(() => {
        hasScrollbar();
        window.addEventListener('resize', hasScrollbar);
        return () => {
            window.removeEventListener('resize', hasScrollbar);
        }
    }, [info])

    return (
        <tbody>
            {
                info.map( line =>{
                    return(
                       <OneCallback key={line.callback_idx} item={line}  handleEdit={handleEdit} />
                    );
                })
            }
        </tbody>
    );

}

export default CallbackList;